import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api'
import store from '@/store'
import useModal from '@/@core/components/base-modal/hooks/useModal'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { privilegeImageModel } from '@/models/privilege/privilege-form'

export default function useManageImageListModal(props) {
  const { openModal, closeModal } = useModal()
  const {
    openSuccessModal,
    openDefaultErrorModal,
    openWarningModal,
  } = useValidationModal()
  const { fetchGroupImageList } = privilegeImageModel()

  const vm = getCurrentInstance().proxy

  const formData = reactive({
    groupImageId: 0,
    imageType: 1,
    name: '',
    descEn: '',
    descTh: '',
    key: '',
    remark: '',
    imageList: [],
    imageDelList: [],
  })

  const imageTypeOptions = ref([
    { text: 'Single Image', value: 1 },
    { text: 'Multiple Image', value: 2 },
  ])

  const onChangeImgType = e => {
    if (formData.imageType == 1) {
      formData.imageList = []
    }
  }

  const fetchImageDetail = () => {
    window.$loading(true)
    fetchGroupImageList.payload.Privilege_Id = props.imageObj.privilegeId
    fetchGroupImageList.payload.Group_Image_Id = props.imageObj.selectId

    store
      .dispatch('api/apiRequest', fetchGroupImageList)
      .then(async resp => {
        const respData = resp.data.resp
        formData.groupImageId = respData.group_image_id
        formData.imageType = respData.type
        formData.name = respData.name
        formData.key = respData.key
        formData.imageList = respData.imagelist
        formData.descTh = respData.desc_th
        formData.descEn = respData.desc_en
        formData.remark = respData.remark
      })
      .catch(err => {
        openDefaultErrorModal()
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const fetchImageData = () => {
    if (props.isEdit) fetchImageDetail()
  }

  const onUploadImage = fileData => {
    formData.imageList.push({
      image_id: 0,
      file: fileData.file,
      image_url: fileData.url,
    })
  }

  const onDeleteImage = () => {
    formData.imageList = []
  }

  const onUploadImageMultiple = fileData => {
    fileData.map(o => {
      formData.imageList.push(o)
    })
  }

  const onDeleteImageMultiple = item => {
    if (item.image_id !== 0) formData.imageDelList.push(item.image_id)
    formData.imageList.splice(formData.imageList.indexOf(item), 1)
  }

  const onSubmitModal = () => {
    if (formData.imageType == 1) {
      const delList = []
      if (formData.imageList.length > 1) {
        formData.imageList.map(o => {
          if (o.image_id !== 0) {
            delList.push(o.image_id)
          }
        })
      }

      if (delList.length > 0) formData.imageDelList.push(...delList)
      formData.imageDelList = [...new Set(formData.imageDelList)]
    }

    vm.$emit('onSubmit', formData, props.isEdit)
  }

  return {
    formData,
    imageTypeOptions,
    fetchImageData,
    onUploadImage,
    onDeleteImage,
    onUploadImageMultiple,
    onDeleteImageMultiple,
    onSubmitModal,
    onChangeImgType,
  }
}
